<template>
  <div class="section-preview-select-column">
    <div class="section-inner">
      <div v-if="!mapDataFilter.length" class="d-flex flex-column align-items-center justify-content-center text-center section-empty-preview">
        <filter-empty-icon class="filter-empty-icon mb-2" />
        <div class="topic">
          <span>{{ t('component.filter_table.components.preview_filter.no_filter') }}</span>
        </div>
      </div>
      <div v-else class="section-content-preview">
        <div v-for="(previewItem, previewItemIndex) in mapDataFilter" :key="previewItemIndex" class="content-preview-inner">
          <div class="group-preview">
            <div class="filter-container">
              <div class="content">{{ previewItem.column_alias }}</div>
            </div>
            <div class="filter-container mx-2">
              <div class="content">
                {{
                  previewItem.Select_Flag
                    ? t('communication.all')
                    : onConvertShowItem(previewItem.Datas, previewItem.column_selected.date_format, previewItem.column_selected.type_desc)
                }}
              </div>
            </div>
            <div class="filter-container">
              <div class="preview-result text-center" id="ListBtn">
                <table-icon class="table-icon" @click="onLoadPreviewResult(previewItem)" />
              </div>
            </div>
            <div v-if="mapDataFilter.length > 1" class="filter-container">
              <div class="btn-close-preview text-center" @click="onRemoveObject(previewItem)">x</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="result-data-filter" v-if="isOpenPreviewData">
      <div class="content-column" :class="previewDataList.length < 6 ? 'lessResult' : 'moreResult'" id="ListGroup">
        <div class="btn-close-preview text-center" @click="closePreviewData">x</div>
        <div class="data-container" :class="{ itemBlur: isLoading }">
          <div class="column-name">{{ previewData.column_alias }}</div>
          <div class="list-filter" v-if="isLoadingDisplayModal">
            <div class="item-loading">
              <loader-spinner />
            </div>
          </div>
          <div v-else-if="previewDataList.length == 0" class="list-filter" @scroll="onScrolled">
            <div class="item">No Item</div>
          </div>
          <div v-else class="list-filter" @scroll="onScrolled">
            <div v-for="(item, index) in previewDataList" :key="index" class="item">{{ onConvertItem(item, previewData.label) }}</div>
            <transition name="fade">
              <div class="loading-result" v-if="isLoading">
                <loader-spinner />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import TableIcon from '@/assets/icons/base/table/TableIcon.vue';
import FilterEmptyIcon from '@/assets/icons/base/table/FilterEmpty.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';

import usePreviewSelectColumn from '../hooks/usePreviewSelectColumn';

interface Props {
  previewTableId: number;
  dataPreviewTable: any;
}
const props = defineProps<Props>();

defineEmits(['on-preview', 'on-remove-item']);

const { t } = useI18n();
const {
  mapDataFilter,
  isLoadingDisplayModal,
  isOpenPreviewData,
  previewData,
  previewDataList,
  isLoading,
  closePreviewData,
  onConvertItem,
  onScrolled,
  onRemoveObject,
  onLoadPreviewResult,
  onConvertShowItem,
} = usePreviewSelectColumn(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/filter-table/preview-select-column.scss';
</style>
